// src/pages/AppraiserDirectory.js
// HomeIQa — Appraiser Directory (Coming Soon)
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AppraiserDirectory() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#FAF7F2', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: "'Inter', sans-serif" }}>
      <div style={{ maxWidth: 520, textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🏠</div>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 32, color: '#5B1A2A', marginBottom: 12 }}>
          Appraiser Directory
        </h1>
        <div style={{ display: 'inline-block', background: '#D4A017', color: '#fff', padding: '6px 20px', borderRadius: 20, fontSize: 13, fontWeight: 700, letterSpacing: '0.05em', marginBottom: 24 }}>
          COMING SOON
        </div>
        <p style={{ fontSize: 16, color: '#4a3728', lineHeight: 1.7, marginBottom: 24 }}>
          We're building a verified directory of licensed appraisers in your area. Every appraiser will be verified against the Appraisal Subcommittee (ASC) National Registry with monthly license checks.
        </p>
        <p style={{ fontSize: 14, color: '#8b7355', lineHeight: 1.6, marginBottom: 32 }}>
          In the meantime, get an AI-powered home valuation report for just $29 — no appraiser needed for refinancing decisions, pre-listing prep, or understanding your home's equity.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => navigate('/start')} style={{ background: '#5B1A2A', color: '#fff', border: 'none', padding: '14px 28px', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
            Get Your Report — $29
          </button>
          <button onClick={() => navigate('/')} style={{ background: 'transparent', color: '#5B1A2A', border: '2px solid #5B1A2A', padding: '14px 28px', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
